import { config as baseConfig } from './base-config';
import { config as dev } from './dev';
import { config as local } from './local';
import { config as prd } from './prd';
import { config as prdGv } from './prd-gv';
import { config as prdTraining } from './prd-training';
import { Configuration, Environment } from './types';
import { config as uat } from './uat';
import { config as uatGv } from './uat-gv';

import merge from 'deepmerge';

const configurations: Record<Environment, Partial<Configuration>> = {
  local,
  dev,
  uat,
  'uat-gv': uatGv,
  prd,
  'prd-gv': prdGv,
  'prd-training': prdTraining,
};

Object.entries(configurations).forEach(([key, config]) => {
  const enrichedConfig = merge(baseConfig, config);

  configurations[key as Environment] = enrichedConfig;
});

export default configurations as Record<Environment, Configuration>;
